import axios from 'axios';
import { getAccessToken } from '../common/utils';

// Get the API base URL from environment variables
const getApiBaseUrl = () => {
  const env = process.env.REACT_APP_ENV;

  if (env === 'prod') {
    const url = process.env.REACT_APP_PROD_API_URL;
    console.log('API Config: Using production environment');
    return url;
  } else {
    const url = process.env.REACT_APP_DEV_API_URL;
    console.log('API Config: Using development environment');
    return url;
  }
};

// Create axios instance
const axiosInstance = axios.create({
  baseURL: getApiBaseUrl(),
  timeout: 10000,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Request interceptor to add authorization token
axiosInstance.interceptors.request.use(
  async (config) => {
    try {
      const accessToken = await getAccessToken();
      if (accessToken) {
        config.headers.Authorization = accessToken;
      }
    } catch (error) {
      console.error('Error getting access token:', error);
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor for error handling
axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    console.error('API Error:', error.response?.data || error.message);
    return Promise.reject(error);
  }
);

export const getDashboard = async (customer = null) => {
  const url = customer ? `/get-data?customer=${encodeURIComponent(customer)}` : '/get-data';
  const response = await axiosInstance.get(url);
  return response.data;
};

export const getDashboardNew = async (customer = null) => {
  const url = customer ? `/dashboard-new?customer=${encodeURIComponent(customer)}` : '/dashboard-new';
  const response = await axiosInstance.get(url);
  return response.data;
};

export const createTeam = async (teamData) => {
  const response = await axiosInstance.post('update-team', teamData);
  return response.data;
};

export const updateTeam = async (teamData, customer = null, team = null) => {
  const response = await axiosInstance.post('update-team', {
    ...teamData,
    ...(customer && { customer }),
    ...(team && { team }),
  });
  return response.data;
};

export const deleteTeam = async (teamData) => {
  const response = await axiosInstance.post('update-team', teamData);
  return response.data;
};

export const getStakeholder = async () => {
  const response = await axiosInstance.get('/stakeholder');
  return response.data;
};

export const getTeamDetails = async (customerKey, teamKey) => {
  const response = await axiosInstance.get(`/team/${encodeURIComponent(customerKey)}/${encodeURIComponent(teamKey)}`);
  return response.data;
};

export const updateTeamData = async (data, customer = null, team = null, pk = null, gsiPk = null) => {
  const response = await axiosInstance.post('update-team', {
    ...data,
    ...(customer && { customer }),
    ...(team && { team }),
    ...(pk && { ["customerName#teamName"]: pk }),
    ...(gsiPk && { gsiPk }),
  });
  return response.data;
};

// Export the axios instance for custom requests
export { axiosInstance };

